import React from 'react';
import { Button, } from '../../components';
import { useHistory } from 'react-router-dom';
import { useSelector } from '../../Redux/store';
const BackToTopButton = React.memo(() => {
    const history = useHistory();
    const mobileApplicationStore = useSelector(state => state.mobileApplication);
    // トップに戻る
    const handleBack = () => {
        history.push('/tool/top');
    };
    return (React.createElement(React.Fragment, null, mobileApplicationStore ?
        React.createElement("a", { className: 'inline-block bg-gray-400 text-white text-xl font-bold rounded-full py-1.5 px-4 shadow-md text-center', href: 'gemba://home' }, "\u4E00\u89A7\u3078\u623B\u308B")
        :
            React.createElement(Button, { addClasses: ['inline-block', 'bg-gray-400', 'text-white', 'text-xl', 'font-bold', 'rounded-full'], label: '一覧へ戻る', disabled: false, onClick: handleBack })));
});
export default BackToTopButton;
